module.exports = "/assets/138597edac6549c9f58e57f0926ed622.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/EG.png
// module id = 1335
// module chunks = 0